import React from 'react';
import { getCourseBackgroundImage, getCourseColor } from '../utils/classroomUtils';

const ActiveClasses = ({ googleUser, classes, recentClass }) => {

    const handleCourseClick = (course) => {
        // Use alternateLink and add authuser parameter
        let courseUrl = course.alternateLink;

        // Add authuser parameter to the URL
        const url = new URL(courseUrl);
        url.searchParams.set('authuser', googleUser.email);

        window.open(url.toString(), '_blank');
    };

    return (
        <div>
            {classes.length > 0 && (
                <div>
                    <h3>Google Classroom Classes:</h3>
                    <div className="courses-container">
                        {classes.filter(course => recentClass(course)).map(course => {
                            const backgroundImage = getCourseBackgroundImage(course);
                            const backgroundColor = getCourseColor(course.id);

                            return (
                                <div
                                    key={course.id}
                                    className="course-card"
                                    style={{
                                        backgroundImage: backgroundImage ? `url(${backgroundImage})` : 'none',
                                        backgroundColor: backgroundImage ? 'transparent' : backgroundColor,
                                    }}
                                    onClick={() => handleCourseClick(course)}
                                >
                                    <div className="course-card-overlay" />

                                    <div className="course-card-content">
                                        <div className="course-card-header">
                                            <h3 className="course-card-title">
                                                {course.name}
                                            </h3>
                                            {course.section && (
                                                <p className="course-card-section">
                                                    Period {course.section}
                                                </p>
                                            )}
                                        </div>
                                        <div className="course-card-footer">
                                            {course.room && (
                                                <p className="course-card-room">
                                                    Room: {course.room}
                                                </p>
                                            )}
                                        </div>
                                    </div>
                                </div>
                            );
                        })}
                    </div>
                </div>
            )}
        </div>
    );
};

export default ActiveClasses;